import { h, Component } from 'preact'
import ProjectsAPI from '../api/ProjectsAPI'
import Projects from '../components/Projects'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      projects: [],
      count: 3,
      isLoading: true,
      error: false,
    }
  }

  componentDidMount() {
    this.fetchProjects()
  }

  fetchProjects() {
    this.setState({ isLoading: true })

    let promises = ProjectsAPI.all()

    Promise.all(promises)
    .then(results => {
      // flatten results into one array
      let data = [].concat.apply([], results)

      // sort data by date
      data.sort(this.latestFirst)

      // get the first few projects
      let limitedData = data.slice(0, this.state.count)

      window.setTimeout(() => {
        this.setState({
          projects: limitedData,
          isLoading: false
        })
      }, 500)
    })
    .catch(error => {
      this.setState({
        error: true,
        isLoading: false
      })
    })
  }

  latestFirst(a,b) {
    if (a.date > b.date)
      return -1;
    if (a.date < b.date)
      return 1;
    return 0;
  }

  render() {
    return (
      <div className="c-recent-news-app">

        <Projects
          projects={this.state.projects}
          loading={this.state.isLoading}
          error={this.state.error}
          language={this.props.language}
        />

      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/js/recent-news/containers/App.js